import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { UiCardPage } from '@standardkit/ui';

@Component({
  imports: [RouterOutlet, UiCardPage],
  templateUrl: 'card.layout.html',
})
export class CardLayout {}
